import React from "react";
import ImageUploaded from "../../../src/assets/images/image_uploaded.svg";
import Image from "lib/Image";

const VideoUploaded = (props) => {
  const {
    fileName,
    fileSize,
    removeUploadedFile,
    error,
    isEditable,
    is_disabled,
    selectedData,
    remove_disabled,
    isDisabLed,
    previewImage,
    liveness
  } = props;

  let sizeInMB = fileSize !== null ? (fileSize / (1024 * 1024)).toFixed(2) : "";

  return (
    <div className="upload-container">
      <Image imageSrc={ImageUploaded} />
      <div className="upload-rightContainer">
        <div className="upload-content">
          <span>{fileName}</span>
          {!error  ? (
            <>
              <button
                className={`remove_button ${
                  isDisabLed
                    ? true
                    : isEditable !== undefined
                    ? !isEditable && "radioDisabled"
                    : ""
                }`}
                disabled={
                  remove_disabled
                    ? false
                    : selectedData &&
                      is_disabled &&
                      is_disabled !== undefined &&
                      eval(is_disabled)
                    ? true
                    : isDisabLed
                    ? false
                    : isEditable !== undefined
                    ? !isEditable
                    : false
                }
                onClick={removeUploadedFile}
              >
                Remove
              </button>
            </>
          ) : (
            
            <button className="remove_button" onClick={removeUploadedFile}>
              Re-take
            </button>
          )}
        </div>
        {!error ? (
          <span>{sizeInMB && `${sizeInMB}MB`}</span>
        ) : (
          <span className="error_file">
            {sizeInMB && `${sizeInMB}MB`} Invalid file
          </span>
        )}
      </div>

    </div>    
    );
};

export default VideoUploaded;
